import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

export const useNumberFilterStyles = makeStyles((theme: Theme) => ({
  numberFilterAdornment: {
    display: 'flex',
    paddingLeft: '5px',
    '& button': {
      padding: '0px 4px',
      borderRadius: 0,
      minWidth: '25px',
      fontSize: '1.1rem',
      '&.active': {
        backgroundColor: theme.palette.action.selected,
      },
    },
  },
}));

export default makeStyles((theme: Theme) => ({
  totals: {
    margin: '1px -16px',
    display: 'flex',
    flexBasis: 'calc(100% + 32px)',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: theme.palette.action.hover,
    position: 'relative',
  },
  filter: {
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
    'button&': {
      height: 'fit-content',
      backgroundColor: theme.palette.action.hover,
    },
  },
  filterContainer: {
    marginTop: theme.spacing(-1),
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(-2),
    },
  },
  filterSkeleton: {
    display: 'block',
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
    borderRadius: '4px',
    '&.checkbox': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
  },
  dropdownFiltersWrapper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  menu: {
    '& ul': {
      minWidth: '185px',
    },
  },
  model: {
    display: 'inline-flex',
    textAlign: 'left',
    alignItems: 'center',
    '& .label': {
      flexGrow: 1,
      paddingRight: theme.spacing(1),
    },
  },
  toolbar: {
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  hidden: {
    visibility: 'hidden',
  },
  deviceCount: {
    marginTop: theme.spacing(2),
    fontSize: '1rem',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      right: 0,
      top: 0,
      marginTop: theme.spacing(0.25),
    },
  },
  filterChip: {
    marginRight: theme.spacing(1),
    '&.skeleton': {
      borderRadius: '16px',
    },
  },
  filtersRow: {
    marginBottom: theme.spacing(1),
  },
  marginBottom: {
    marginBottom: theme.spacing(2),
  },
  pullRight: {
    textAlign: 'right',
  },
  textFilter: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    width: '305px',

    '& .MuiFormHelperText-root': {
      color: theme.palette.primary.main,
    },

    '&.first': {
      marginLeft: theme.spacing(0),
    },

    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(1, 0, 0, 0),
      width: '65%',
    },

    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1, 0, 0, 0),
      width: '100%',
    },
  },
  textFilterSkeleton: {
    marginLeft: theme.spacing(3),
    width: '290px',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    '& span': {
      borderRadius: '4px',
    },

    '&:first-child': {
      marginLeft: theme.spacing(0),
    },

    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(1, 0, 0, 0),
      width: '65%',
    },

    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1, 0, 0, 0),
      width: '100%',
    },
  },
}));
